const endpoints = {
  pauseMachine: '/managed_machines/bulk_pause_alerts',
  unpauseMachine: '/managed_machines/bulk_unpause_alerts',
};

export default endpoints;
